export default {
    buildDir: '.nuxt-build-jest',
    buildDirRootPath: '@/.nuxt-build-jest',
    port: 3001,
};
